import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function PainSection() {
  return <section id="pain-section" className="py-16 md:py-32 bg-[#0a1628] relative overflow-hidden" data-id="element-234">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#1e3a5f] to-transparent" data-id="element-235" />

      <div className="max-w-3xl mx-auto px-5 md:px-6" data-id="element-236">
        <FadeIn data-id="element-237">
          <div className="text-center mb-10 md:mb-16" data-id="element-238">
            <h2 className="text-2xl md:text-5xl text-white mb-4 md:mb-6" data-id="element-239">
              El patrón real{' '}
              <span className="text-[#64748b] text-xl md:text-3xl block mt-2 font-normal font-sans" data-id="element-240">
                (lo que te está pasando)
              </span>
            </h2>
          </div>
        </FadeIn>

        <div className="space-y-8 md:space-y-12 text-base md:text-xl text-gray-300 leading-relaxed" data-id="element-241">
          <FadeIn data-id="element-242">
            <p data-id="element-243">Tú no tienes "un problema de motivación".</p>
            <p className="text-white font-semibold mt-2 text-xl md:text-2xl" data-id="element-244">
              Tienes un problema de arquitectura diaria.
            </p>
          </FadeIn>

          <FadeIn delay={0.1} data-id="element-245">
            <p data-id="element-246">Porque cada vez que intentas cambiar, haces lo mismo:</p>

            <div className="mt-6 md:mt-8 relative pl-8 border-l-2 border-[#1e3a5f] space-y-4 md:space-y-6" data-id="element-247">
              {['Te emocionas', 'Te exiges demasiado', 'Fallas', 'Te culpas', 'Abandonas', 'Vuelves a empezar semanas después'].map((item, index) => <div key={index} className="flex items-center" data-id="element-248">
                  <span className="absolute -left-[9px] w-4 h-4 rounded-full bg-[#0a1628] border-2 border-[#d4af37]" data-id="element-249" />
                  <span className="text-gray-200" data-id="element-250">{item}</span>
                </div>)}
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-251">
            <div className="bg-[#1e3a5f]/30 p-6 md:p-8 rounded-lg border border-[#1e3a5f] mt-8 md:mt-12 text-center" data-id="element-252">
              <p className="text-lg md:text-2xl italic font-serif text-[#d4af37]" data-id="element-253">
                "Y así se te va el año."
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-254">
            <p className="text-center text-lg md:text-2xl mt-8 md:mt-12" data-id="element-255">
              Lo que estás perdiendo no es un hábito.
              <br data-id="element-256" />
              <span className="text-white font-bold border-b-2 border-[#d4af37]" data-id="element-257">
                Es confianza personal.
              </span>
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}